import { useNav } from "../hooks/useNav";

export const useIsWorkNumber = () => {
  const { pathname } = useNav();
  return pathname.includes("/update-work-number");
};
